import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './redux/store';
import './index.css';
// import './styles/global-theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.body.classList.add('gt-themed');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker: register only in production builds. In CRA dev (npm start)
// the SW caches stale chunks and silently breaks new routes / nav entries on
// normal refresh — only Ctrl+Shift+R works. Disable in dev, and on first load
// in dev unregister any leftover SW from a previous prod-style build.
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
  } else {
    // Unregister anything previously registered + clear all caches so the
    // browser stops serving stale bundles for users who hit a SW once.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    }).catch(() => {});
    if (window.caches && caches.keys) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
    }
  }
}
